module.exports = __webpack_public_path__ + "static/turtle-promo-43d69faca77e6cc0b8abf17cb36146b1.mp4";